<template>
  <div class="allcontant">
      <el-main>
        <!-- <div class="bread">
        <h1>大赛新闻</h1>
        <el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item :to="{ path: 'news' }">大赛新闻</el-breadcrumb-item>
</el-breadcrumb></div> -->
        <div class="newbox">
          <div>
            <div class="title">
              <h3 @click="gotoMore">大赛动态</h3>
              <p @click="gotoMore(1)">more>></p>
            </div>
             <div v-for="item in matchList" :key="item.id" class="news">
               <img :src="item.img">
                  <div  @click="toinfo(item.id)">
                    <h3>{{item.title}}</h3>
               <div  class="fuwen">{{item.content}}
               </div>
                    <p>{{item.createTime}}</p>

                  </div>
             </div>
          </div>
         
        </div>
           <div class="newbox">
          <div>
            <div class="title">
              <h3 @click="gotoMore">学校动态</h3>
              <p @click="gotoSchoolMore">more>></p>
            </div>
             <div v-for="item in schoolList" :key="item.id" class="news">
               <img :src="item.img">
                  <div  @click="toinfo(item.id)">
                    <h3>{{item.title}}</h3>
               <div  class="fuwen">{{item.content}}
               </div>
                    <p>{{item.createTime}}</p>

                  </div>
             </div>
          </div>
         
        </div>
      </el-main>
  </div>
</template>

<script>
import { Session } from '@/utils/storage';
import {getData} from "@/api/news"
export default {
 data(){
   return{
     params:{
       page:1,
       limit:5,
       matchId:'',
       orderRule: "create_time"
     },
     matchList:{},
     schoolList:{},
      // imgUrl:"http://wlzj-platform.test.upcdn.net/"
   }
 },
 mounted(){
   this.getList()
 },
 methods:{
   getList(){
     this.params.matchId = Session.get("matchID")
     getData(this.params).then(res=>{
       this.matchList = res.data.data.matchList.list
       this.matchList.forEach(item=>{
         item.content = item.content.replace(/<[^>]+>/g, "");
         item.content = item.content.replace(/[ ]|[&nbsp;]/g, '')
       })
       this.schoolList = res.data.data.schoolList.list
        this.schoolList.forEach(item=>{
        item.content = item.content.replace(/<[^>]+>/g, "");
         item.content = item.content.replace(/[ ]|[&nbsp;]/g, '')
       })
     })
   },
   gotoMore(e){
     this.$router.push({path:"/NewsMore",query:{type:e}})
   },
   gotoSchoolMore(){
     this.$router.push({path:"/SchoolMore"})
   },
   toinfo(e){
    this.$router.push({path:'/newsInfo',query:{id:e}})
  }
 }
}
</script>

<style scoped>
.allcontant {
    height: auto;
    min-height: calc(100vh - 140px);
    margin-top: 100px;
    /* background-color: #f1f1f1; */
    margin-bottom: -30px;
    margin-top: 70px;
}
.el-main{
  width: 65%;
  margin: 0 auto;
  display: flex;
}
.newbox{
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
}
.newbox>div{
  width: 100%;
  min-height: 315px;
  /* background-color: #f5f5f5; */
  margin: 0 20px;
  overflow: hidden;
}
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border-bottom: 1px solid;  */
}
.title p,.title h3{
  margin: 15px;
}
.bread{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.news{
  display: flex;
 align-items: center;
    border-bottom: 1px solid #ccc;
    padding-bottom: 15px;
}
.news img {
    width: 160px;
    padding: 10px;
    height: 120px;
    min-width: 160px;
}
.fuwen{
   text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.news h3{
  min-height: 28px;
  cursor: pointer !important;
	overflow: hidden; /*文本超出隐藏*/
	display:-webkit-box; /*盒子模型微弹性伸缩模型*/
	-webkit-box-orient: vertical;/*伸缩盒子的子元素垂直排列*/
	-webkit-line-clamp: 2; /*文本显示3行*/
  font-size: 19px;
    font-weight: 600;
    letter-spacing: 2px;
}
.news h3:hover{
  color: #00baff;
}
.title:hover {
    cursor: pointer;
}
@media screen and (max-width:900px){
  main.el-main {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-top: 30px;
}
.newbox{
  width: 100%;
}

.newbox>div {
    min-height: 0;
    max-height: 295px;
    
}
.notice h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px !important;
}
p.fuwen {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    width: 20rem;
}
.news img {
    width: 12rem !important;
    height: 10rem;
        min-width: 12rem !important;
}
}
</style>


// WEBPACK FOOTER //
// src/components/News.vue